import { TableBody, TableCell, TableRow } from '@/components/ui/table';
import type { TableLoadingViewProps } from '../types';
import { VisibleCenter } from './VisibleCenter';

export function TableLoadingView({ columnCount }: TableLoadingViewProps) {
  return (
    <TableBody>
      <TableRow>
        <TableCell
          colSpan={columnCount}
          className="px-4 py-6 text-muted-foreground"
        >
          <VisibleCenter>Loading…</VisibleCenter>
        </TableCell>
      </TableRow>
    </TableBody>
  );
}
